<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>STUDENT SATISFACTION SURVEY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Student Satisfaction Survey</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
            <div class="container text-white bg-primary" style="background-color:ActiveCaption">

                <div class="modal-body">
                    <div>
                        <div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Name</label>
                                    <input type="text" class="form-control livetime" id="enqname"
                                           placeholder="Enter Name" maxlength="150">
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputPassword4">Mobile</label>
                                    <input type="email" class="form-control" id="enqemail" placeholder="Mobile">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-10">
                                    <label for="inputPassword4">Please confirm this is the first and only time you
                                        answer this survey</label>
                                    <select id="ddlconfirm" class="form-control">
                                        <option value=""></option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>

                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="inputPassword4">Age:</label>
                                    <input type="text" class="form-control" id="enqalternatemobile" placeholder="Age"
                                           maxlength="10">
                                </div>
                            </div>
                            <div class="form-row">

                                <div class="form-group col-md-4">
                                    <label for="inputState">School</label>
                                    <select id="ddlschool" class="form-control">
                                        <option>Select School</option>
                                        <option value="ARNI SCHOOL OF ART &amp; HUMANITES">ARNI SCHOOL OF ART &amp;
                                            HUMANITES
                                        </option>
                                        <option value="ARNI SCHOOL OF COMMERCE">ARNI SCHOOL OF COMMERCE</option>
                                        <option value="ARNI SCHOOL OF COMPUTER SCIENCE">ARNI SCHOOL OF COMPUTER
                                            SCIENCE
                                        </option>
                                        <option value="ARNI SCHOOL OF TECHNOLOGY">ARNI SCHOOL OF TECHNOLOGY</option>
                                        <option value="ARNI SCHOOL OF BUSINESS MANAGEMENT">ARNI SCHOOL OF BUSINESS
                                            MANAGEMENT
                                        </option>
                                        <option value="ARNI SCHOOL OF BASIC SCIENCE">ARNI SCHOOL OF BASIC SCIENCE
                                        </option>
                                        <option value="ARNI SCHOOL OF HOSPITALITY &amp; TOURISM MANAGEMENT">ARNI SCHOOL
                                            OF HOSPITALITY &amp; TOURISM MANAGEMENT
                                        </option>
                                        <option value="ARNI SCHOOL OF PHARMACY">ARNI SCHOOL OF PHARMACY</option>
                                        <option value="ARNI SCHOOL OF MSME">ARNI SCHOOL OF MSME</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="inputState">Gender</label>
                                    <select id="ddlgender" class="form-control">
                                        <option value="">Gender</option>
                                        <option value="M">M</option>
                                        <option value="F">F</option>

                                    </select>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="inputState">Degree/Program Pursuing Now</label>
                                    <select id="Degree/Program Pursuing Now" class="form-control">
                                        <option value="">Select Degree/Program</option>
                                        <option value="Bachelor">Bachelor</option>
                                        <option value="Master">Master</option>
                                        <option value="MPhil">MPhil</option>
                                        <option value="Doctorate">Doctorate</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="inputState">Subject Area </label>
                                    <select id="ddlsubjectarea" class="form-control">

                                        <option value="Select Subject Area">Select Subject Area</option>
                                        <option value="Arts">Arts</option>
                                        <option value="Commerce">Commerce</option>
                                        <option value="Science">Science</option>
                                        <option value="Professional">Professional</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div class="col-md-12">
                                    <h5 class="text-center">Following are questions for online student satisfaction
                                        survey regarding teaching learning process.</h5>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="inputState">1. How much of the syllabus was covered in the
                                        class? </label>
                                    <select id="ddl1" class="form-control">

                                        <option value="">Select Option</option>
                                        <option value="85 to 100%">85 to 100%</option>
                                        <option value="70 to 84%">70 to 84%</option>
                                        <option value="55 to 69%">55 to 69%</option>
                                        <option value="30 to 54%">30 to 54%</option>
                                        <option value="Below 30%">Below 30%</option>
                                    </select>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="inputState">2. How well did the teachers prepare for the
                                        classes? </label>
                                    <select id="ddl2" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Thoroughly">Thoroughly</option>
                                        <option value="Satisfactorily">Satisfactorily</option>
                                        <option value="Poorly">Poorly</option>
                                        <option value="Indifferently">Indifferently</option>
                                        <option value="Won’t teach at all">Won’t teach at all</option>
                                    </select>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="inputState">3. How well were the teachers able to communicate?</label>
                                    <select id="ddl3" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Always effective">Always effective</option>
                                        <option value="Sometimes effective">Sometimes effective</option>
                                        <option value="Just satisfactorily">Just satisfactorily</option>
                                        <option value="Generally ineffective">Generally ineffective</option>
                                        <option value="Very poor communication">Very poor communication</option>
                                    </select>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="inputState">4. The teacher’s approach to teaching can best be described
                                        as</label>
                                    <select id="ddl4" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Excellent">Excellent</option>
                                        <option value="Very good">Very good</option>
                                        <option value="Good">Good</option>
                                        <option value="Fair">Fair</option>
                                        <option value="Poor">Poor</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">5. Fairness of the internal evaluation process by the
                                        teachers.</label>
                                    <select id="ddl5" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Always fair">Always fair</option>
                                        <option value="Usually fair">Usually fair</option>
                                        <option value="Sometimes unfair">Sometimes unfair</option>
                                        <option value="Usually unfair">Usually unfair</option>
                                        <option value="Unfair">Unfair</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">6. Was your performance in assignments discussed with
                                        you?</label>
                                    <select id="ddl6" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Every time">Every time</option>
                                        <option value="Usually">Usually</option>
                                        <option value="Occasionally/Sometimes">Occasionally/Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">7. The institute takes active interest in promoting
                                        internship, student exchange, field visit opportunities for students.</label>
                                    <select id="ddl7" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Regularly">Regularly</option>
                                        <option value="Often">Often</option>
                                        <option value="Sometimes">Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">8. The teaching and mentoring process in your institution
                                        facilitates you in cognitive, social and emotional growth.</label>
                                    <select id="ddl8" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Significantly">Significantly</option>
                                        <option value="Very well">Very well</option>
                                        <option value="Moderately">Moderately</option>
                                        <option value="Marginally">Marginally</option>
                                        <option value="Not at all">Not at all</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">9. The institution provides multiple opportunities to learn
                                        and grow.</label>
                                    <select id="ddl9" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Strongly agree">Strongly agree</option>
                                        <option value="Agree">Agree</option>
                                        <option value="Neutral">Neutral</option>
                                        <option value="Disagree">Disagree</option>
                                        <option value="Strongly disagree">Strongly disagree</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">10. Teachers inform you about your expected competencies,
                                        course outcomes and programme outcomes.</label>
                                    <select id="ddl10" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Every time">Every time</option>
                                        <option value="Usually">Usually</option>
                                        <option value="Occasionally/Sometimes">Occasionally/Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">11. Your mentor does a necessary follow-up with an assigned
                                        task to you.</label>
                                    <select id="ddl11" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Every time">Every time</option>
                                        <option value="Usually">Usually</option>
                                        <option value="Occasionally/Sometimes">Occasionally/Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">12. The teachers illustrate the concepts through examples
                                        and applications.</label>
                                    <select id="ddl12" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Every time">Every time</option>
                                        <option value="Usually">Usually</option>
                                        <option value="Occasionally/Sometimes">Occasionally/Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">13. The teachers identify your strengths and encourage you
                                        with providing right level of challenges.?</label>
                                    <select id="ddl13" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Fully">Fully</option>
                                        <option value="Reasonably">Reasonably</option>
                                        <option value="Partially">Partially</option>
                                        <option value="Slightly">Slightly</option>
                                        <option value="Unable to">Unable to</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">14. Teachers are able to identify your weaknesses and help
                                        you to overcome them.</label>
                                    <select id="ddl14" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Every time">Every time</option>
                                        <option value="Usually">Usually</option>
                                        <option value="Occasionally/Sometimes">Occasionally/Sometimes</option>
                                        <option value="Rarely">Rarely</option>
                                        <option value="Never">Never</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">15. The institution makes effort to engage students in the
                                        monitoring, review and continuous quality improvement of the teaching learning
                                        process.</label>
                                    <select id="ddl15" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Strongly agree">Strongly agree</option>
                                        <option value="Agree">Agree</option>
                                        <option value="Neutral">Neutral</option>
                                        <option value="Disagree">Disagree</option>
                                        <option value="Strongly disagree">Strongly disagree</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">16. The institute/ teachers use student centric methods,
                                        such as experiential learning, participative learning and problem solving
                                        methodologies for enhancing learning experiences.</label>
                                    <select id="ddl16" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="To a great extent">To a great extent</option>
                                        <option value="Moderate">Moderate</option>
                                        <option value="Some what">Some what</option>
                                        <option value="Very little">Very little</option>
                                        <option value="Not at all">Not at all</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">17. Teachers encourage you to participate in extracurricular
                                        activities.</label>
                                    <select id="ddl17" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="To a great extent">Strongly agree</option>
                                        <option value="Agree">Agree</option>
                                        <option value="Neutral">Neutral</option>
                                        <option value="Disagree">Disagree</option>
                                        <option value="Strongly disagree">Strongly disagree</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">18. Efforts are made by the institute/ teachers to inculcate
                                        soft skills, life skills and employability skills to make you ready for the
                                        world of work.</label>
                                    <select id="ddl18" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="To a great extent">To a great extent</option>
                                        <option value="Moderate">Moderate</option>
                                        <option value="Some what">Some what</option>
                                        <option value="Very little">Very little</option>
                                        <option value="Not at all">Not at all</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">19. What percentage of teachers use ICT tools such as LCD
                                        projector, Multimedia, etc. while teaching.</label>
                                    <select id="ddl19" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="Above 90%">Above 90%</option>
                                        <option value="70 – 89%">70 – 89%</option>
                                        <option value="50 – 69%">50 – 69%</option>
                                        <option value="30 – 49%">30 – 49%</option>
                                        <option value="Below 29%">Below 29%</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">20. The overall quality of teaching-learning process in your
                                        institute is very good.</label>
                                    <select id="ddl20" class="form-control">
                                        <option value="">Select Option</option>
                                        <option value="To a great extent">Strongly agree</option>
                                        <option value="Agree">Agree</option>
                                        <option value="Neutral">Neutral</option>
                                        <option value="Disagree">Disagree</option>
                                        <option value="Strongly disagree">Strongly disagree</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-12 col-lg-12 col-sm-12">
                                    <label for="inputState">21. Give three observation / suggestions to improve the
                                        overall teaching – learning experience in your institution.<br>
                                        <span>Suggestions for Improvement</span></label>
                                    <textarea id="message" name="message1" autocomplete="off" required=""
                                              class="notebook" rows="7" cols="135"></textarea>
                                </div>
                                <hr>
                                <br>
                                <div class="col-md-12">
                                    <center><input type="button" class="button-default btn btn-secondary" value="Submit" id="enqsubmit"
                                                   style="height: 50px;"></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</section>
